<script>
import dayjs from '../../core/dayjs';

export default {
  props: {
    message: {
      type: Object,
      required: true,
    },
    attendant: {
      type: String,
      required: true,
    },
    lead: {
      type: Object,
      required: true,
    },
  },

  data () {
    return {

    };
  },

  computed: {
    isAttendant () {
      const attendantMessages = ['admin', 'batch', 'api', 'agent', 'auto'];

      return attendantMessages.includes(this.message.direction);
    },

    shouldApplySentByMarginTop () {
      const vCardRegex = /^BEGIN:VCARD[\s\S]*END:VCARD$/i;

      if (
          this.message.file
          || (this.message.parent_message && this.message.parent_message.file)
        ) {
          return true;
        }

      if (
          vCardRegex.test(this.message.text)
          || (this.message.parent_message && vCardRegex.test(this.message.parent_message.text))
        ) {
        return true;
      }


      return false;
    },
  },

  methods: {
    getTimeInDay (date) {
      return dayjs(date).format('HH:mm');
    },

    getDay (date) {
      return dayjs(date).format('DD/MM/YYYY');
    }
  }
};
</script>

<template>
  <div
    class="attendance-message w-100 d-flex align-items-start py-1 px-2"
  >
    <div
      class="sent-by"
      :class="{
        'is-attendant': isAttendant,
        'mt-2': shouldApplySentByMarginTop,
      }"
    >
      <span class="sent-by-name">{{ isAttendant ? attendant : lead.name || lead.phone || lead.whatsapp || lead.email }}</span>
      <span>:</span>
    </div>
    <div
      class="content-container ml-2"
    >
      <div v-if="message.parent_message" class="parent-message d-flex align-items-start p-1">
          <span
            class="response-text"
            :class="{ 'mt-2': message.parent_message.file }"
          >
            {{ __('Respondeu') }}:
          </span>
          <LeadAttendenceMessageContent
            :message="message.parent_message"
            :isParent="true"
          />
      </div>
      <LeadAttendenceMessageContent
        :message="message"
      />
      <span
        class="time"
      >
        <span>{{ getTimeInDay(message.send_date) }}</span>
        <span class="ml-2">{{ getDay(message.send_date) }}</span>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '../../../sass/variables';
  @import '../../../sass/mixins';

  .attendance-message {
    .sent-by {
      width: 100px;
      min-width: 100px;
      display: flex;
      @include salesflow-text($font-weight: 600);

      &.is-attendant {
        color: $salesflow-font-gray;
      }

      .sent-by-name {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .parent-message {
      width: fit-content;
      gap: 4px;
      border-radius: 4px;
      background-color: $salesflow-bg-body;
      font-style: italic;
      max-width: 16rem;

      @media (min-width: 1300px) {
        max-width: 26rem;
      }

      .response-text {
        font-weight: 600;
      }

      .message-plain-text {
        color: $salesflow-font-gray;
      }
    }

    .content-container {
      width: 100%;
      display: flex;
      flex-direction: column;

      @include salesflow-text($font-weight: 500);
    }

    .time {
      @include salesflow-label($color: $salesflow-font-gray);
    }
  }
</style>
